import { IncomeService } from "../services";

const extractBuildingId = (params) => {
  if (!params) return undefined;
  if (typeof params === "number") return params;
  if (typeof params === "object") {
    if (typeof params.buildingId === "number") return params.buildingId;
    if (typeof params.buildingId === "object") return params.buildingId?.id;
    if (typeof params.building === "number") return params.building;
    if (typeof params.building === "object") return params.building?.id;
    if (typeof params.id === "number") return params.id;
  }
  return undefined;
};

export const income = {
  state: () => ({
    incomes: [],
    selectedIncomes: [],
    current: null,
  }),
  mutations: {
    setIncomes: (state, value) => (state.incomes = value || []),
    setSelectedIncomes: (state, value) => (state.selectedIncomes = value || []),
    setCurrentIncome: (state, value) => (state.current = value || null),
  },
  actions: {
    INCOME_FIND_ALL: async ({ commit }, params) => {
      const response = await IncomeService.findAll(params || {});
      if (response.ok) {
        commit("setIncomes", response.data || []);
      } else {
        alert(response.message || "No fue posible obtener los ingresos");
      }
      return response;
    },
    INCOME_FIND_ONE: async ({ commit }, id) => {
      const response = await IncomeService.findById(id);
      if (response.ok) {
        commit("setCurrentIncome", response.data || null);
      } else {
        alert(response.message || "No fue posible obtener el ingreso");
      }
      return response;
    },
    INCOME_CREATE: async ({ dispatch }, payload) => {
      const response = await IncomeService.create(payload);
      if (response.ok) {
        const buildingId = extractBuildingId(payload?.buildingId ?? payload);
        if (buildingId) {
          await dispatch("INCOME_FIND_ALL", { buildingId });
        }
      }
      return response;
    },
    INCOME_UPDATE: async ({ dispatch }, { id, ...payload }) => {
      const response = await IncomeService.update({ id, ...payload });
      if (response.ok) {
        const buildingId = extractBuildingId(payload?.buildingId ?? payload);
        if (buildingId) {
          await dispatch("INCOME_FIND_ALL", { buildingId });
        }
      }
      return response;
    },
    INCOME_DELETE: async ({ dispatch }, { id, buildingId }) => {
      const response = await IncomeService.remove(id);
      if (response.ok) {
        const resolvedBuildingId = extractBuildingId(buildingId);
        if (resolvedBuildingId) {
          await dispatch("INCOME_FIND_ALL", { buildingId: resolvedBuildingId });
        }
      }
      return response;
    },
    INCOME_DOWNLOAD_EXCEL: async (_, params) => IncomeService.exportExcel(params),
    INCOME_DOWNLOAD_PDF: async (_, params) => IncomeService.exportPdf(params),
    INCOME_NOTIFY: async (_, payload) => IncomeService.notify(payload),
  },
  getters: {
    incomeById: (state) => (id) => state.incomes.find((item) => item.id === id) || null,
  },
};

